import React from 'react';
import './styles.css';


function Footer(){
    return (
        <footer>
            
        </footer>
    );
}


export default Footer;